module.exports = __webpack_public_path__ + "static/pic-4@2x-d0d6197d87afab340577fff7643c6096.png";